import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/people.png'


const _withScopeId = n => (_pushScopeId("data-v-898bc61a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-plaza-ctn flex-column" }
const _hoisted_2 = { class: "search-ctn flex-row" }
const _hoisted_3 = { class: "set_select_all" }
const _hoisted_4 = { class: "select_all" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list flex-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "info-ctn flex-column" }
const _hoisted_9 = { class: "h3" }
const _hoisted_10 = { class: "tit van-ellipsis" }
const _hoisted_11 = { class: "people" }
const _hoisted_12 = {
  class: "touxiang",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "imgel",
  fit: "cover",
  src: _imports_0,
  alt: ""
}
const _hoisted_15 = { class: "name" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = { class: "has" }
const _hoisted_18 = { class: "del" }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = { class: "zan" }
const _hoisted_21 = { class: "t_l" }

import { ref, onMounted, watch, onBeforeMount, onActivated } from "vue"
import { showNotify } from "vant"
import Cities from "@/components/Cities.vue"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import router from "@/router"
import { onBeforeRouteLeave, useRoute } from "vue-router"
import { getPublicKey, dicAPi } from "@/api/login"
import { searchApi } from "@/api/projectDemand"
import { addFeedBackApi, getNewCodeApi, addCodeApi, updateCodeApi } from "@/api/home"
import DataList from "@/api/common"
import { getTokenIn, getCityCode, getNoLogincityCodeXm, getNoLoginCityCodeHome } from "@/utils/cookies"

const __default__ = {
  name: "projectDemand"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const getDataAPI = searchApi
const resource_type = ref([]) //资源类型
const itemRef = ref()
const listRef: any = ref(null)
const params: any = ref({})
const addNum = ref(0)
const formDatas: any = ref({
  xqlx: "", //发布类型
  zylxs: [], //资源类型
  //   value3: "" //排序
  szcsbm: getNoLoginCityCodeHome() || "",
  isCity: 1
})
const cityParams: any = ref({
  name: "",
  code: "",
  add: false,
  sfid: ""
}) //定位参数
const dropdownMenus: any = [
  {
    key: "xqlx",
    name: "发布类型",
    option: [
      { text: "不限", value: "" },
      { text: "寻找资产", value: "0" },
      { text: "我有资产", value: "1" }
    ]
  },
  {
    key: "zylxs",
    name: "资源类型"
  },
  {
    key: "timeOrder",
    name: "排序",
    option: [
      // { text: "默认排序", value: 0 },
      { text: "发布时间顺序", value: 0 },
      { text: "发布时间倒序", value: 1 }
    ]
  }
]
const list: any = ref([])
const rateVal: any = ref(4)
const gotoDetail = (item: any) => {
  // if (getToken()) {
  //记录浏览量
  var datas = {
    originalSfid: item.sfid,
    type: "project"
  }
  addFeedBackApi(datas).then(() => {})
  // }
  // 缓存滚动条滚动的高度
  const height: any = document.getElementsByClassName("flex-1")[0].scrollTop
  sessionStorage.setItem("projectDemandScroll", height)
  router.push({ path: "/projectDemand/detail", query: { id: item.sfid } })
}
// const onSearch = (val: string) => {
//   params.value.key = val
//   list.value = []
// }
const onClear = () => {
  // 重新搜索
  // reSearch()
}
const reSearch = () => {
  list.value = []
  listRef.value.onRefresh()
}
const onChange = () => {
  // 需要判断是新增还是编辑，再记录用户定位参数
  // 未登录进行缓存
  sessionStorage.setItem("noLogincityCodeHome", formDatas.value.szcsbm)
  // if (cityParams.value.add) {
  //   // 新增
  //   addCodeDetail()
  // } else {
  //   // 编辑
  //   editCodeDetail()
  // }
  reSearch()
}
onBeforeMount(() => {
  // 获取用户最新的位置记录
  // getCityCodeDetail()
})
onActivated(() => {
  if (route.meta.isReach) {
    formDatas.value.szcsbm = getNoLoginCityCodeHome() || ""
    reSearch()
  }
  if (route.meta.catch && !route.meta.keepAlive && !route.meta.isReach) {
    const height: any = sessionStorage.getItem("projectDemandScroll")
    document.getElementsByClassName("flex-1")[0].scrollTop = height || 0
  }
})
onMounted(() => {
  getAllDict() //获取字典
  formDatas.value.isCity = 2
  // if (getNoLoginCityCodeHome()) {
  //   formDatas.value.isCity = 2
  //   formDatas.value.szcsbm = getNoLoginCityCodeHome()
  // }
})
// 获取用户最新位置信息，如果没有获取到就用定位信息，如果获取到就用记录的位置信息
const getCityCodeDetail = async () => {
  getNewCodeApi("首页").then((res: any) => {
    if (res.code == 200) {
      if (res.data == null) {
        // 表明从未记录用户定位信息
        cityParams.value.add = true
        formDatas.value.isCity = 2
        // setTimeout(() => {
        //   // 使用定位参数
        //   formDatas.value.szcsbm = getCityCode() || "350200"
        //   reSearch()
        // }, 100)
      } else {
        //使用记录的的定位参数
        cityParams.value.add = false
        formDatas.value.isCity = 2
        setTimeout(() => {
          formDatas.value.szcsbm = res.data.code
          cityParams.value.sfid = res.data.sfid
          reSearch()
        }, 100)
      }
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 添加用户操作的城市选择
const addCodeDetail = () => {
  if (getTokenIn()) {
    addCodeApi({
      code: formDatas.value.szcsbm,
      pageCode: "首页"
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res)
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 编辑用户操作的城市选择
const editCodeDetail = () => {
  if (getTokenIn()) {
    updateCodeApi({
      code: formDatas.value.szcsbm,
      pageCode: "首页",
      sfid: cityParams.value.sfid
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res)
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("resource_type")
  if (res.code == 200) {
    resource_type.value = res.data
  }
}
// 资源类型选择
const select = (item: any) => {
  console.log(item)
  //  多选
  var index = formDatas.value.zylxs.indexOf(item.code)
  if (index !== -1) {
    formDatas.value.zylxs.splice(index, 1)
  } else {
    formDatas.value.zylxs.push(item.code)
  }
}
watch(
  () => formDatas.value.zylxs.length,
  () => {
    reSearch()
  }
)
// watch(
//   () => formDatas.value.szcsbm,
//   (newVal, oldVal) => {
//     addNum.value += 1
//     if (addNum.value === 1 && getTokenIn()) {
//       setTimeout(() => {
//         // 获取用户最新的位置记录
//         if (getTokenIn()) {
//           getCityCodeDetail()
//         }
//       }, 300)
//     }
//   },
//   {
//     deep: true,
//     immediate: true
//   }
// )
//资源类型全选
const selectAll = () => {
  // resource_type
  if (resource_type.value?.length === formDatas.value?.zylxs.length) {
    //  取消全选
    formDatas.value.zylxs = []
  } else {
    formDatas.value.zylxs = []
    resource_type.value.map((item: any) => {
      formDatas.value.zylxs.push(item.code)
    })
  }
}
// 资源类型取消
const onClickOff = () => {
  formDatas.value.zylxs = []
  itemRef.value[0]?.toggle()
  // 重新搜索
  reSearch()
}
// 资源类型确认
const onClickBq = async () => {
  itemRef.value[0]?.toggle()
  reSearch()
}
// 获取头像
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Cities, {
        city: formDatas.value.szcsbm,
        "onUpdate:city": _cache[0] || (_cache[0] = ($event: any) => ((formDatas.value.szcsbm) = $event)),
        nullCityName: "城市",
        onChange: onChange
      }, null, 8, ["city"]),
      _createVNode(_component_van_search, {
        modelValue: formDatas.value.xqbt,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((formDatas.value.xqbt) = $event)),
          reSearch
        ],
        class: "system-search",
        placeholder: "输入搜索关键词",
        shape: "round",
        clearable: "",
        "show-action": "",
        onSearch: reSearch,
        onClear: onClear,
        onCancel: onClear
      }, null, 8, ["modelValue"])
    ]),
    true
      ? (_openBlock(), _createBlock(_component_van_dropdown_menu, {
          key: 0,
          class: "system-dropdown-menu",
          "active-color": "#f1c241"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownMenus, (item, i) => {
              return _createElementVNode("div", { key: i }, [
                (item.name == '资源类型')
                  ? (_openBlock(), _createBlock(_component_van_dropdown_item, {
                      key: 0,
                      ref_for: true,
                      ref_key: "itemRef",
                      ref: itemRef,
                      title: item.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", {
                              onClick: selectAll,
                              class: _normalizeClass(formDatas.value.zylxs.length == resource_type.value.length ? 'active' : '')
                            }, "全选", 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource_type.value, (item, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: i,
                                onClick: ($event: any) => (select(item)),
                                class: _normalizeClass(formDatas.value.zylxs.indexOf(item.code) >= 0 ? 'active' : '')
                              }, _toDisplayString(item.code), 11, _hoisted_5))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  : (_openBlock(), _createBlock(_component_van_dropdown_item, {
                      key: 1,
                      modelValue: formDatas.value[item.key],
                      "onUpdate:modelValue": ($event: any) => ((formDatas.value[item.key]) = $event),
                      options: item.option,
                      title: item.name,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (reSearch()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "title"]))
              ])
            }), 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ListWithRefreshAndLazyLoad, {
        ref_key: "listRef",
        ref: listRef,
        list: list.value,
        "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((list).value = $event)),
        params: formDatas.value,
        getDataAPI: _unref(getDataAPI)
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-item flex-row",
              key: i,
              onClick: ($event: any) => (gotoDetail(item))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (item.xqlx)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(item.xqlx == '0' ? 'want' : 'has')
                      }, _toDisplayString(item.xqlx == "0" ? "要" : "有"), 3))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.xqbt), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    (item.headResourceDetail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "imgel",
                          fit: "cover",
                          src: getImg(item.headResourceDetail?.sfid),
                          alt: ""
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("img", _hoisted_14))
                  ]),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.userName), 1),
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.zylx), 1)
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(item.xqms), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(item.shelfTime), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("i", _hoisted_20, _toDisplayString(item.dzs > 99 ? "99+" : item.dzs), 1),
                    _createElementVNode("i", _hoisted_21, _toDisplayString(item.pls > 99 ? "99+" : item.pls), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "params", "getDataAPI"])
    ])
  ]))
}
}

})